module.exports = __webpack_public_path__ + "img/customer.5110a7e4.jpg";